import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Http from "../../../Common/Http";
import LoaderComponent from "../../../Common/LoaderComponent";
import IsLogin from "../../../Common/IsLogin";
import { Alert } from "bootstrap";


const Setdetails = () => {
    const { id } = useParams();
    const [receiveData, setReceiveData] = useState(null);
    const [alert, setAlert] = useState(null);
    const [loading, setLoading] = useState(false);

    // Fetch the planning data
    const fetchData = async () => {
        // setLoading(true);
        try {
            const response = await Http.get(`/sets/${id}`);
            setReceiveData(response.data);
        } catch (error) {
            Swal.fire("Error!", "Failed to fetch planning details.", "error");
        } finally {
            //   setLoading(false);
        }
    };
    console.log(receiveData, "receiveData");

    useEffect(() => {
        fetchData();
    }, [id]);

    //   const showAlert = (message, type) => {
    //     setAlert({
    //       message: message,
    //       type: type,
    //     });
    //     setTimeout(() => {
    //       setAlert(null);
    //     }, 4000);
    //   };

    //   useEffect(() => {
    //     if (location.state) {
    //       showAlert(location.state.message, location.state.type);
    //     }
    //   }, [location]);

    //   if (loading || !receiveData) {
    //     return <LoaderComponent />;
    //   }

    return (
        <div>
            <IsLogin />
            <div className="am-mainpanel">
                <div className="am-pagetitle">
                    <h5 className="am-title">Set Report</h5>
                </div>
                <div className="am-pagebody">
                    {/* <Alert alert={alert} /> */}
                    <div className="card pd-20 pd-sm-40">
                        <div className="text-center">
                            <img
                                src="https://artisan.projectsample.info/backend/public/image/artisan-logo.jpeg"
                                width="20%"
                            />
                            {/* <h5 className="text-uppercase text-sm font-weight-bolder">
                Artisan Ceramics Limited
              </h5>
              <p>House-16, Road-07, Sector-01, Uttara, Dhaka</p> */}
                        </div>

                        {/* General Work Order Details */}
                        <div className="d-flex mt-3 mb-3 justify-content-between">


                            <div className="mb-0">
                                <p>
                                    <strong>Receipt No:</strong> {receiveData?.code}
                                </p>
                                <p>
                                    <strong>Set Name:</strong> {receiveData?.name}
                                </p>
                            </div>
                            <div className="mb-0">
                                <p>
                                    <strong>Work Order:</strong> {receiveData?.production_work_order?.receipt_no}
                                </p>
                                <p>
                                    <strong>Company:</strong> {receiveData?.production_work_order?.company?.name}
                                </p>
                            </div>

                        </div>

                        {/* Item Table */}
                        <div className="table-responsive p-0 pb-2">
                            <table className="table table-sm table-bordered table-striped align-items-center mb-0 _datatable">
                                <thead>
                                    <tr>
                                        <th>S/N</th>
                                        <th>Product Name</th>
                                        <th>Shape</th>
                                        <th>Decoration Name</th>
                                        <th>Decoration Code</th>
                                        <th>Color Name</th>
                                        <th>Qty</th> {/* New Shape column */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {receiveData?.items.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{item?.product?.name}</td>

                                            <td>{item?.production_work_order_item?.shape?.name || "N/A"}</td>
                                            <td>{item?.production_work_order_item?.decoration_name}</td>
                                            <td>{item?.production_work_order_item?.decoration?.code || "N/A"}</td>
                                            <td>{item?.production_work_order_item?.color?.colour_name || "N/A"}</td>
                                            <td>{item?.qty || "N/A"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Setdetails;
